<template>
  <b-container fluid>
    <div class="card">
      <div class="card-body">
        <h4 class="mb-4">
          <strong>Filtros de Busca</strong>
        </h4>
        <a-form layout="vertical">
          <div class="row">
            <div class="col-md-4">
              <a-form-item label="Nome">
                <a-input placeholder="Nome" v-model="filtrosLocal.name" />
              </a-form-item>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <b-button class="col-12" @click="limparFiltros">Limpar</b-button>
            </div>
            <div class="col-md-2">
              <b-button class="col-12" @click="filtrar" variant="outline-primary">Filtrar</b-button>
            </div>
          </div>
        </a-form>

      </div>
    </div>
    <template v-if="loading">
      <div class="d-flex justify-content-center bd-highlight mb-3">
        <div class="spinner-border" role="status">
          <span class="sr-only">Carregando...</span>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- Main table element -->
      <b-table
        show-empty
        stacked="md"
        :items="displayItens"
        :fields="fields"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:cell(startValue)="data">
          {{ (data.value ) | money }}
        </template>
        <template v-slot:cell(endValue)="data">
          {{ (data.value ) | money}}
        </template>

        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click="editarItem(row)" class="mr-1">
            <i class="fe fe-edit"></i>
          </b-button>
        </template>

        
          <template v-slot:cell(remove)="row">

          <b-button size="sm"    @click="removecommercialPolicy(`${row.item.id}`)"
            ><i  :v-if="!loading"  class="fe fe-trash"></i>
            <b-spinner
            small
            variant="primary"
            label="Spinning"
            v-show="loading"
          ></b-spinner>
            </b-button>

        </template>

       
      </b-table>
    </template>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          @input="onChangePage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { CanalDeVendasResource } from '@/resources/CanalDeVenda.resource.js'
export default {
  name: 'ListaPoliticaComercial',
  components: {
  },
  data() {
    return {
      loading: false,
      filtrosLocal: {
        index: 1,
        size: 5,
        name: "",
      },
      itens: [],
      displayItens: [],
      fields: [
        { key: 'idSaleChannelCommercialPolicy', label: 'ID', sortable: true, sortDirection: 'desc' },
        { key: 'name', label: 'Nome', sortable: true, sortDirection: 'desc' },
        { key: 'startValue', label: 'Valor Inicial', sortable: true, sortDirection: 'desc' },
        { key: 'endValue', label: 'Valor Final', sortable: true, sortDirection: 'desc' },
        { key: 'actions', label: 'Editar' },
         { key: 'remove', label: 'Remover' },
        
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      statusDispositivos: [],
      adquirentes: [],
      itemEditar: null,
    }
  },
  methods: {

    removecommercialPolicy(id){

       this.$bvModal.msgBoxConfirm('Voce deseja excluir a politica comercial ', {
          title: 'Confirmação',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'SIM',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if(value === true)
            {
                  this.loading = true;
                  var payload = {
                    idMerchantFile : parseInt(id), 
                    fileName : name
                  };


                    CanalDeVendasResource.deleteMerchantFile(payload)
                    .then(result => {
                        this.loading = false;
                          this.filtrar();
                          this.$notification["success"]({
                            message:
                              "Arquivo excluído",
                            description: "",
                          });

                    })
                    .catch((e) =>{
                        this.loading = false;
                        this.$notification["error"]({
                            message:
                              "Ocorreu um erro",
                            description: "",
                          });
                    })


            }
           
          })
          .catch(err => {
            // An error occurred
          })

    },
    // lista de todos os dispositivos cadastrados
    getLista() {
      if (typeof this.itens[this.filtrosLocal.index] === 'undefined') {
        // nessa situacao, precisamos buscar os dados, pois ainda nao forma consultados...
        this.loading = true
        CanalDeVendasResource.getListaPoliticaComercial(this.filtrosLocal).then((result) => {
          try{
            this.itens[this.filtrosLocal.index] = result.data.payload.items;
            this.displayItens = this.itens[this.filtrosLocal.index].flat()
            this.totalRows = result.data.payload.pageSettings.total;
            this.loading = false
          } catch(e) {
            throw {
              response: {
                data: {
                  failureReason: 'Deu ruim na chamada...'
                }
              }
            }
          }
        })
        .catch((e) => { 
          this.loading = false
        })
      } else {
        // se já temos, apenas movesmo para a lista de exibicao...
        this.displayItens = this.itens[this.filtrosLocal.index].flat()
      }
    },
    onChangePage(a) {
      // uma mudanca do page filter ocorreu, vamos atualizar a lista...
      this.filtrosLocal.index = a
      this.getLista()
    },
    editarItem(row){
      this.$router.push({
        name: 'politica-comercial-editar',
        params: {
          id: row.item.idSaleChannelCommercialPolicy
        }
      })
    },
    limparFiltros() {
      this.filtrosLocal = {
        index: 1,
        size: 5,
        name: ""
      }
      this.filtrar()
    },
    filtrar(){
      // se algum item do filtro for 0, mudar para null
      this.filtrosLocal.name = this.filtrosLocal.name === null ? '' : this.filtrosLocal.name
      this.itens = []
      this.displayItens = []
      this.currentPage = 1
      this.getLista()
    }
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  mounted() {
    this.filtrar()
  },
  created(){
    this.getLista()
  },
}
</script>
